var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"price-value tw-flex tw-items-baseline"},_vm._l((_vm.priceParts),function(part,index){return _c('span',{key:index,class:part.class},[_vm._v(" "+_vm._s(part.value)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }